// extracted by mini-css-extract-plugin
export default {"invert":"BVELwMSJiv17I7aaU4gq","menu":"PCdFnDnGL8pKDmE7fiih","divider":"xPD6thWqmYgGiiPLMsB7"};